import script from "./deviceSelect2.vue?vue&type=script&setup=true&lang=js"
export * from "./deviceSelect2.vue?vue&type=script&setup=true&lang=js"

import "./deviceSelect2.vue?vue&type=style&index=0&id=681d0af4&lang=less"

const __exports__ = script;

export default __exports__